import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET NOTIFICATIONS FOR ADMIN ******
export const fetchCurrentAdminNotifications = (data: {
  page?: number;
  adminKey: string;
}) =>
  axiosInstance
    .post<{
      success: boolean;
      remaining: number;
      notifications: {
        article: string;
        createdAt: string;
        isSeen: boolean;
        notificationTitle: string;
        _id: string;
      }[];
    }>(
      `/notification/all/admin`,
      {
        page: data?.page,
      },
      {
        headers: {
          authorization: `Bearer ${data?.adminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET NOTIFICATIONS Count FOR ADMIN ******
export const fetchUnseenNotificationCountForAdmin = (data: {
  adminKey: string;
}) =>
  axiosInstance
    .get<{
      success: boolean;
      notSeen: number;
    }>(`/notification/seen/admin`, {
      headers: {
        authorization: `Bearer ${data?.adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** Mark Read notifications ******
export const markNotificationsAsReadForAdmin =
  (adminKey: string) => (ids: string[]) =>
    axiosInstance
      .post(
        `/notification/make/seen/admin`,
        {
          ids,
        },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
